import { stableKeys } from "../utils/common.ts";

export const APIErrorCodeMap = {
  "50600": "INSUFFICIENT_AMOUNT_OF_CREDITS",
  "50610": "RATE_LIMIT_EXCEEDED",
} as const;
export const APIValidErrorCode = stableKeys(APIErrorCodeMap);
export type APIError = (typeof APIErrorCodeMap)[keyof typeof APIErrorCodeMap];
